import { createActions } from '@/utils/actions';

const { actions: billing } = createActions('billing')
  .add('cleanUp')
  .addAsync('getCustomer')
  .add('getInvoices')
  .add('getShops')
  .addAsync('getShop')
  .addAsync('getShopInvoices')
  .addAsync('manageShop')
  .add('setData')
  .add('togglePaymentMethodModal');

export default billing;
